import React, {useState, useEffect,useContext} from "react";
import { useTranslate } from 'react-redux-multilingual';
import { EditModalActionButton, HeadInfos, CreatePersonalizedPriceForm,ToastPopUp, AddItemToList} from "@gull";
import axios from 'axios'
import swal from "sweetalert2";
import { allPersonalizedPrice,personalizedPricePrefixe,personalizedPricePercent} from 'app/allPersonalizedPrice';
import { Modal } from "react-bootstrap";
import { IsAuthContext} from 'app/App';
import Moment from 'react-moment';
import { devises_list } from "app/devises";
import PersonalizedPriceItemList from './PersonalizedPriceItemList'

const useLoadInit = (id,reload) => {
    const t = useTranslate();
    const [loading,setLoading]=useState(true)
    const [liaisons,setLiaisons]=useState([])
    const [customFields,setCustomFields]=useState(false)

    const [articles,setArticles]=useState([])
    const [sizeDatas,setSizeDatas]=useState(0)
    const [customInterface, setCustomInterface] = useState({})
    
    const [sendData, setSendData] = useState({})

    const [optionsDataTable,setOptionsDataTable]=useState({
        devise:[],
        marque:[],
        fournisseur:[],
        firstlevelcat:[],
        secondlevelcat:[],
        thirdlevelcat:[],
        fourthlevelcat:[],
        fifthlevelcat:[]

    })
    const [ourOptionsDataTable,setOurOptionsDataTable]=useState({
        devise:{},
        marque:{},
        fournisseur:{},
        firstlevelcat:{},
        secondlevelcat:{},
        thirdlevelcat:{},
        fourthlevelcat:{},
        fifthlevelcat:{}

    })

    useEffect(function () {
        (async function() {
            setCustomInterface({})
            const response = await axios.post(process.env.REACT_APP_API_URL+"api/erp/personalized_price/get_article_of_personalized_price/"+id+"/50/1"
            ).then((response) => {
                setLoading(false)
                setArticles(response.data.datas)
                setSizeDatas(response.data.count)
                let allFilter = {
                    havestock:"",
                };
                if(response.data.custom_interface.user_conf){
                    response.data.custom_interface.user_conf.details.map(value=>
                        allFilter[value]=[]
                    )
                }else if(response.data.custom_interface.default_conf){
                    response.data.custom_interface.default_conf.details.map(value=>
                        allFilter[value]=[]
                    )
                }

                setSendData(allFilter)
                setCustomInterface(response.data.custom_interface)

            }).catch((error) => {
                if(error=='end_session') return;
                let messageError
                if(error.response==undefined){
                    messageError='unknowError'
                }
                else if(error.response.status==403){
                    messageError='forbiddenGeneral'
                }
                else {
                    messageError='unknowError'
                }
                
                swal.fire(messageError, "", "error");
            })
            setLoading(false)
        })()
    }, [reload])
    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/article/liaison"
            ).then((response) => {
                setLiaisons(response.data.datas)

                
                let arr = ['firstlevelcat','secondlevelcat','thirdlevelcat','fourthlevelcat','fifthlevelcat','fournisseur','marque']
                //on crée une zone de stockage temporaire des données avant de tout set
                let optionsDataTableTemp = optionsDataTable
                let ourOptionsDataTableTemp = ourOptionsDataTable
                
                //formatage des options du select dans le cell edit du datatable pour les devises
                let arrDevise=[]
                let objDeviseOur={}
                devises_list.map(value=>{
                    arrDevise.push({'value':value.name+" - "+value.code,'label':value.name+" - "+value.code})
                    objDeviseOur[value.name+" - "+value.code]=value.code
                })

                optionsDataTableTemp={...optionsDataTableTemp,devise:arrDevise}
                ourOptionsDataTableTemp={...ourOptionsDataTableTemp,devise:objDeviseOur}

                //formatage des options du select dans le cell edit du datatable pour le reste des colones
                arr.forEach(item=>{
                    let optionsArr = [{'value':t('emptyValue'),'label':t('emptyValue')}]
                    let ourOptionObj = {}

                    ourOptionObj[t('emptyValue')]=''
                    response.data.datas[item].map(value=>{
                        optionsArr.push({'value':value.name,'label':value.name})
                        ourOptionObj[value.name]=value.id
                    })

                    optionsDataTableTemp={...optionsDataTableTemp,[item]:optionsArr}
                    ourOptionsDataTableTemp={...ourOptionsDataTableTemp,[item]:ourOptionObj}
                })

                setOptionsDataTable(optionsDataTableTemp)
                setOurOptionsDataTable(ourOptionsDataTableTemp)
            }).catch((error) => {
                if(error=='end_session') return;
                let messageError
                if(error.response==undefined){
                    messageError='unknowError'
                }
                else if(error.response.status==403){
                    messageError='forbiddenGeneral'
                }
                else {
                    messageError='unknowError'
                }
                
                swal.fire(messageError, "", "error");
            })
        })()
    }, [])
    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/custom_fields/all/article"
            ).then((response) => {
                setCustomFields(response.data.datas)
            }).catch((error) => {
                if(error=='end_session') return;
                let messageError
                if(error.response==undefined){
                    messageError='unknowError'
                }
                else if(error.response.status==403){
                    messageError='forbiddenGeneral'
                }
                else {
                    messageError='unknowError'
                }

                swal.fire(messageError, "", "error");
            })
        })()
    }, [])

    return [loading,articles,setArticles,sizeDatas,setSizeDatas,liaisons,customInterface,setCustomInterface,sendData,setSendData,customFields,optionsDataTable,ourOptionsDataTable]
}

const PersonalizedPriceProfil = (props) => {
    const t = useTranslate();
    const [loading,articles,setArticles,sizeDatas,setSizeDatas,liaisons,customInterface,setCustomInterface,sendData,setSendData,customFields,optionsDataTable,ourOptionsDataTable] = useLoadInit(props.personalizedPriceId, props.reload)
    const [showCreate,setShowCreate]=useState(false)
    
    const [showAccordion,setShowAccordion]=useState(false) 
    const [toast,setToast]=useState(false) 
    const { authParam } = useContext(IsAuthContext)
    const suppPrice = authParam.company.advanceparams.hasOwnProperty('prix_supplementaire') ? authParam.company.advanceparams.prix_supplementaire : []
    const categorieTva = (authParam.company.advanceparams.hasOwnProperty('categorie_tva') && authParam.company.advanceparams.categorie_tva!=null) ? authParam.company.advanceparams.categorie_tva : []
    const maxConditionnement = (authParam.company.advanceparams.max_conditionnement!='' && authParam.company.advanceparams.max_conditionnement!=null) ? +authParam.company.advanceparams.max_conditionnement : 0

    let devise = authParam.company.devise;

    let statePromo = (props.personalizedPrice.status==0) ? t('finished') : (props.personalizedPrice.status==1) ? t('currentPersonalizedPrice') : t('upcomingPersonalizedPrice')
    let colorStatePromo = (props.personalizedPrice.status==0) ? 'fs-6 text' : (props.personalizedPrice.status==1) ? 'fs-6 text text-success' : 'fs-6 text text-warning'

    let promo
    let listCompany = ''

    if(personalizedPricePrefixe.includes(props.personalizedPrice.type)){
        if(personalizedPricePercent.includes(props.personalizedPrice.type)){
            if(props.personalizedPrice.value.length>1){
                let promoStr = ''
                props.personalizedPrice.value.map(promoAmount=>{
                    promoStr += '-'+promoAmount+'% '
                })
                promo = promoStr
            }else{
                promo = '-'+props.personalizedPrice.value+'%'
            }
        }else{
            promo = '-'+props.personalizedPrice.value+devise
        }
    }else{
        promo = props.personalizedPrice.value
    }

    if(Object.keys(props.personalizedPrice).length!=0 && props.personalizedPrice.company.length!=0) listCompany += props.personalizedPrice.company[0].code
    if(Object.keys(props.personalizedPrice).length!=0 && props.personalizedPrice.other_company.length!=0){
        for(var i=0; i<props.personalizedPrice.other_company.length; i++){
            if(listCompany==''){
                listCompany += props.personalizedPrice.other_company[i].code
            }else{
                listCompany += ', '+props.personalizedPrice.other_company[i].code
            }
            
        }
    }

    const closeModal = () =>{
        setShowCreate(false)
    }
    
    const CustomToggleAccordion = ({ children }) => {
    
        let hisClass = (showAccordion) ? "btn btn-sm btn-info mb-3" : "btn btn-sm btn-outline-info mb-3"
        
        return (
            <button
                type="button"
                className={hisClass}
                style={{marginRight:'10px'}}
                onClickCapture={()=>setShowAccordion(!showAccordion)}
            >
                {children}
            </button>
        );
    }

    if(customFields){
        return (<>
            <ToastPopUp 
                showToast={toast}
                setShowToast={setToast}
                message={t('favoriteSaved')}
            />
            <Modal show={showCreate} onHide={() => closeModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('editPersonalizedPrice')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CreatePersonalizedPriceForm 
                        allPersonalizedPrice={allPersonalizedPrice} 
                        closeModal={closeModal}
                        personalizedPrices={props.personalizedPrice}
                        personalizedPriceProfilId={props.personalizedPrice.id}
                        setPersonalizedPrices={props.setPersonalizedPrice}
                        company={props.company}
                        from='profilPromo'
                        clientId={props.clientId}
                    />
                </Modal.Body>
            </Modal>
            {(loading)?
                <span className='d-flex justify-content-center'><div className="spinner-border spinner-border-sm mt-3"></div></span>
            :
                <>
                    <div className='row position-relative'>
                        <div className='col-5'>
                            <div className="row">
                                <HeadInfos titre={props.personalizedPrice.name}/>
                            </div>
                            <div className="row">
                                <div className="col d-flex align-items-baseline">
                                    <span className="fs-4"><EditModalActionButton setShowEdit={setShowCreate} className='fs-5'/></span>&nbsp;&nbsp;
                                    <CustomToggleAccordion>{t('additionToList')}</CustomToggleAccordion>&nbsp;&nbsp;
                                </div>
                            </div>
                        </div>
                        <div className='col-7'>
                            <div className='row'>
                                <div className='col-3'>
                                    <label className='fs-6 text fw-bold' htmlFor="début promo">{t('beginPersonalizedPrice')+' :'}</label><br/>
                                    <span className='fs-6 text'>{props.personalizedPrice.begin != null ? <Moment format="DD/MM/YYYY">{props.personalizedPrice.begin}</Moment> : t('undefined')}</span>
                                </div>
                                <div className='col-3'>
                                    <label className='fs-6 text fw-bold' htmlFor="fin promo">{t('endPersonalizedPrice')+' :'}</label><br/>
                                    <span className='fs-6 text'>{props.personalizedPrice.end != null ? <Moment format="DD/MM/YYYY">{props.personalizedPrice.end}</Moment> : t('undefined')}</span>
                                </div>
                                <div className='col-3'>
                                    <label className='fs-6 text fw-bold' htmlFor="type de promo">{t('typePersonalizedPrice')+' :'}</label><br/>
                                    <span className='fs-6 text'>{t(props.personalizedPrice.type)}</span>
                                </div>
                                <div className='col-3'>
                                    <label className='fs-6 text fw-bold' htmlFor="etat promo">{t('statePersonalizedPrice')+' :'}</label><br/>
                                    <span className={colorStatePromo}>{statePromo}</span>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className='col-3'>
                                    <label className='fs-6 text fw-bold' htmlFor="promo">{t('personalized_price')+' :'}</label><br/>
                                    <span className='fs-6 text'>{promo}</span>
                                </div>
                                <div className='col-3'>
                                    <div>
                                        <label className='fs-6 text fw-bold' htmlFor="weight promo">{t('poids')+' :'}</label><br/>
                                        <span className='fs-6 text'>{props.personalizedPrice.poids}</span>
                                    </div>
                                </div>
                                <div className='col-3'>
                                    <label className='fs-6 text fw-bold' htmlFor="commpanies">{t('relatedCompanies')+' :'}</label><br/>
                                    <span className='fs-6 text'>{listCompany}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            {(showAccordion) &&
                                <AddItemToList 
                                    liaisons={liaisons}
                                    customFields={customFields} 
                                    setToast={setToast}
                                    customInterface={customInterface}
                                    setCustomInterface={setCustomInterface}
                                    setReload={props.setReload}
                                    setShowAccordion={setShowAccordion}
                                    relatedItemsList={props.personalizedPrice}
                                    tableName="baseAddItemToPromo" 
                                    urlAddItems="api/erp/personalized_price/import/"
                                    from='personalized_price'
                                    promotionDetail={props.personalizedPrice}
                                    setPromotionDetail={props.setPersonalizedPrice}
                                />
                            }
                            <PersonalizedPriceItemList 
                                articles={articles}
                                setArticles={setArticles}
                                sizeDatas={sizeDatas}
                                setSizeDatas={setSizeDatas}
                                liaisons={liaisons}
                                customInterface={customInterface}
                                setCustomInterface={setCustomInterface}
                                setReload={props.setReload}
                                sendData={sendData}
                                setSendData={setSendData}
                                customFields={customFields}
                                optionsDataTable={optionsDataTable}
                                ourOptionsDataTable={ourOptionsDataTable}
                                suppPrice={suppPrice}
                                categorieTva={categorieTva}
                                maxConditionnement={maxConditionnement}
                                personalizedPrice={props.personalizedPrice}
                                personalizedPriceId={props.personalizedPriceId}
                            />
                        </div>
                    </div>
                </>
            }
            </>
        )
    }else{
        return false
    }
}

export default PersonalizedPriceProfil;
